import { AccountType, WechatConversationDataType } from "@packages/chat-sdk";
import { Store } from "./store";
export interface WechatChatStoreType {
  selectedConversation?: WechatConversationDataType;
  // 机器人列表
  robotOptions?: { label: string; value: string }[];
  toBePlayedAudios: {
    url: string;
    id: string;
    is_play: boolean;
  }[];
  nextAudioPlayIndex: number;
}

export const wechatChatStore = new Store<WechatChatStoreType>(() => ({
  selectedConversation: undefined,
  robotOptions: [],
  toBePlayedAudios: [],
  nextAudioPlayIndex: -1,
}));
export const wechatChatStoreActions = {
  setSelectedConversation(payload?: WechatConversationDataType) {
    wechatChatStore.set({
      selectedConversation: payload,
    });
  },
  refreshToBePlayedAudios(
    audios: { url: string; id: string; is_play: boolean }[]
  ) {
    wechatChatStore.set({
      toBePlayedAudios: audios,
    });
  },
  refreshNextAudioPlayIndex(index: number) {
    wechatChatStore.set({
      nextAudioPlayIndex: index,
    });
  },
  setRobotOptions(payload: { label: string; value: string }[]) {
    wechatChatStore.set({
      robotOptions: payload,
    });
  },
};
